var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60002 11.8002C2.17567 11.8002 1.7687 11.6316 1.46864 11.3316C1.16857 11.0315 1 10.6245 1 10.2002C1 9.77584 1.16857 9.36887 1.46864 9.06881C1.7687 8.76875 2.17567 8.60017 2.60002 8.60017M15.4002 11.8002C15.8245 11.8002 16.2315 11.6316 16.5316 11.3316C16.8316 11.0315 17.0002 10.6245 17.0002 10.2002C17.0002 9.77584 16.8316 9.36887 16.5316 9.06881C16.2315 8.76875 15.8245 8.60017 15.4002 8.60017M5.00005 5.00013V2.6001M13.0002 5.00013V2.6001",
    stroke: "black",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99923 2.60002C5.44106 2.60002 5.79924 2.24184 5.79924 1.80001C5.79924 1.35818 5.44106 1 4.99923 1C4.5574 1 4.19922 1.35818 4.19922 1.80001C4.19922 2.24184 4.5574 2.60002 4.99923 2.60002Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9992 2.60002C13.4411 2.60002 13.7992 2.24184 13.7992 1.80001C13.7992 1.35818 13.4411 1 12.9992 1C12.5574 1 12.1992 1.35818 12.1992 1.80001C12.1992 2.24184 12.5574 2.60002 12.9992 2.60002Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2001 5H7.80006C5.53763 5 4.40562 5 3.70321 5.72721C3.0008 6.45442 3 7.62483 3 9.96566C3 12.3065 3 13.4769 3.70321 14.2041C4.40562 14.9313 5.53763 14.9313 7.80006 14.9313H8.62007C9.25368 14.9313 9.47688 15.0617 9.91369 15.5369C10.3961 16.0625 11.1433 16.7641 11.8193 16.9274C12.7801 17.1594 12.8881 16.8385 12.6737 15.9225C12.6129 15.6617 12.4601 15.2449 12.6209 15.0017C12.7113 14.8657 12.8609 14.8321 13.1609 14.7649C13.6337 14.6593 14.0241 14.4865 14.2969 14.2041C15.0002 13.4761 15.0002 12.3065 15.0002 9.96566C15.0002 7.62483 15.0002 6.45442 14.2969 5.72721C13.5945 5 12.4625 5 10.2001 5Z",
    stroke: "black",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99766 11.4002C7.45367 11.8858 8.18008 12.2002 8.99769 12.2002C9.8153 12.2002 10.5417 11.8858 10.9977 11.4002M6.60486 8.2002H6.59766M11.4049 8.2002H11.3977",
    stroke: "black",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiflow);
export default __webpack_public_path__ + "static/media/aiflow.4cc38fd11c1304e0f6cce7a649c0b3ea.svg";
export { ForwardRef as ReactComponent };